import { Controller } from 'stimulus'

export default class extends Controller {

  static targets = ['item']

  toggle(event) {
    for(let item of this.itemTargets) {
      if (item.classList.contains('dn')) {
        item.classList.remove('dn')
        item.classList.add('db')
      } else {
        item.classList.add('dn')
        item.classList.remove('db')
      }
    }
  }
}
